import axios from 'axios'
import qs from 'qs'

let apiClient = null
let defaultHolderType = 'Organization'
let defaultHolderId = ''

const JSON_API_HEADERS = {
  Accept: 'application/vnd.api+json',
  'Content-Type': 'application/vnd.api+json',
}

/**
 * Initialize the API client.
 *
 * @param {Object} options
 * @param {string} options.apiBaseUrl - Base URL of the API (e.g. https://api.example.com/api)
 * @param {string} [options.locale] - Default locale
 * @param {string} [options.holderType] - Default holder type (e.g. Organization)
 * @param {string|number} [options.holderId] - Default holder ID
 * @param {string} [options.authToken] - Bearer token for authentication
 * @param {Object} [options.httpClient] - Custom axios instance
 */
export function initApiClient(options) {
  if (options.httpClient) {
    apiClient = options.httpClient
  } else {
    const headers = { ...JSON_API_HEADERS }
    if (options.authToken) {
      headers.Authorization = `Bearer ${options.authToken}`
    }
    apiClient = axios.create({
      baseURL: options.apiBaseUrl.replace(/\/v1\/?$/, '') + '/elixio-connect',
      headers,
      paramsSerializer: function (params) {
        return qs.stringify(params, { encode: false })
      },
    })
  }

  if (options.holderType) defaultHolderType = options.holderType
  if (options.holderId) defaultHolderId = options.holderId
}

export function getApiClient() {
  if (!apiClient) {
    throw new Error(
      '[ElixioConnect] API client not initialized. Call ElixioConnect.install(Vue, { apiBaseUrl }) first.'
    )
  }
  return apiClient
}

export function buildParams(holderId, holderType) {
  return {
    holder_type: holderType || defaultHolderType,
    holder_id: holderId || defaultHolderId,
  }
}

export function setHolder(holderId, holderType) {
  defaultHolderId = holderId
  if (holderType) defaultHolderType = holderType
}

export function getBaseUrl() {
  return apiClient ? apiClient.defaults.baseURL : ''
}
